import {
    FileLibraryControllerClient,
    FileParameter,
    IStoredFileDto,
    Order,
    RemoveFileDto,
    SortBy,
    StoredFileDto,
} from '../clients/services';
import { AuthStore } from '../auth/auth-store';
import clientFactory from './client-factory';

// eslint-disable-next-line no-undef
const serviceUrl = process.env.REACT_APP_SERVICE_URL as string;

export interface IPublicMediaImportResult {
    scannedFileCount: number;
    createdReferenceCount: number;
    existingReferenceCount: number;
}

export class FileLibraryService {
    private readonly client: FileLibraryControllerClient;
    private readonly authStore: AuthStore;

    constructor() {
        this.client = clientFactory.createSecuredClient(FileLibraryControllerClient);
        this.authStore = new AuthStore();
    }

    async listFilesAsync(
        query: string,
        sortBy: SortBy = SortBy.CreatedAt,
        order: Order = Order.Desc,
        category = '',
    ): Promise<IStoredFileDto[]> {
        return await this.client.listFiles(query, sortBy, order, category);
    }

    async uploadFileAsync(file: File, title = '', comment = '', category = ''): Promise<StoredFileDto> {
        const fileParameter: FileParameter = {
            data: file,
            fileName: file.name,
        };
        return await this.client.uploadFile(fileParameter, title, comment, category);
    }

    async deleteFileAsync(id: string): Promise<void> {
        const input = new RemoveFileDto({ id });
        await this.client.deleteFile(input);
    }

    async importPublicMediaReferencesAsync(): Promise<IPublicMediaImportResult> {
        const token = this.authStore.getToken();
        if (!token?.token) {
            throw new Error('Not authenticated.');
        }

        const response = await fetch(`${serviceUrl}/tickets/admin/files/references/import-public-media`, {
            method: 'POST',
            headers: {
                authorization: `Bearer ${token.token}`,
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'Public media import failed.');
        }

        return (await response.json()) as IPublicMediaImportResult;
    }
}
